import { ViewUser } from "../authorization/Permissions";
import { UserResponse } from "../../api-models/response/user/UserResponse";
import { permissionsService } from "../authorization/UserPermissionsService";
import { translationService } from "../translation/TranslationService";
import { RowItemData } from "../../components/datatable/interfaces";
import { EmploymentStatus } from "./EmploymentStatus";
import { Role } from "./Role";
import { SupportTag } from "../../components/grid-tag/Tags";
import { OrganizationInvitationStatuses } from "../../generated/OrganizationInvitations";

export class User implements RowItemData {
  id: number;
  private name: string;
  private organizationInvitationStatus: OrganizationInvitationStatuses;
  private role?: Role;
  private email: string;
  private phone: string;
  private isSupportAccount: boolean;
  private openJobs: number;
  private totalJobs: number;
  private status?: EmploymentStatus;
  private organizationName: string;
  private totalVaCalls: number;
  private vaCallsThisCycle: number;
  private isOrganizationMember: string;

  constructor(userResponse: UserResponse) {
    this.id = userResponse.id;
    this.name = userResponse.name;
    this.organizationInvitationStatus = userResponse.organizationInvitationStatus;
    this.status = userResponse.status ? new EmploymentStatus(userResponse.status) : undefined;
    this.role = userResponse.role ? new Role(userResponse.role) : undefined;
    this.email = userResponse.email;
    this.phone = userResponse.phone;
    this.isSupportAccount = userResponse.isSupportAccount;
    this.openJobs = userResponse.openJobs;
    this.totalJobs = userResponse.totalJobs;
    this.organizationName = userResponse.organizationName;
    this.totalVaCalls = userResponse.totalVaCalls;
    this.vaCallsThisCycle = userResponse.vaCallsThisCycle;
    this.isOrganizationMember = userResponse.isOrganizationMember;
  }

  private get isDeletedAccount() {
    return !this.name && !this.email && !this.phone && !this.isOrganizationMember;
  }

  get displayValues() {
    return {
      name: {
        toDisplay: this.isDeletedAccount ? translationService.translate("general.deleted-account") : this.name,
        id: this.id,
        path: this.path,
        child: this.isSupportAccount ? SupportTag : null,
      },
      organizationInvitationStatus: {
        toDisplay: this.organizationInvitationStatusDisplayName,
      },
      status: {
        toDisplay: this.status && this.status.displayName,
      },
      role: { toDisplay: this.displayRole },
      openJobs: { toDisplay: this.openJobs },
      totalJobs: { toDisplay: this.totalJobs },
      email: { toDisplay: this.email },
      phone: { toDisplay: this.phone },
      totalVaCalls: { toDisplay: this.totalVaCalls },
      vaCallsThisCycle: { toDisplay: this.vaCallsThisCycle },
      isOrganizationMember: { toDisplay: this.displayIsOrganizationMember },
    };
  }

  get path(): any {
    return permissionsService.userHasPermissionTo(ViewUser) ? "/users/:id" : undefined;
  }

  private get displayRole(): any {
    return this.role && translationService.translate(this.role.translationKey);
  }

  private get displayIsOrganizationMember(): string {
    return this.isOrganizationMember
      ? translationService.translate("general.yes")
      : translationService.translate("general.no");
  }

  private get organizationInvitationStatusDisplayName(): any {
    return (
      this.organizationInvitationStatus &&
      translationService.translate(
        `api.organization.invitation.status.${OrganizationInvitationStatuses[this.organizationInvitationStatus]
        }.UserTable`
      )
    );
  }
}
